// extracted by mini-css-extract-plugin
export default {"control":"segmentedControl_control__7d0eY"};